import { ContainerService } from './container.service.js';

export const GlobalContainerService = new ContainerService();
